__turbopack_context__.v({
  "wrapper": "link-trip-action-module__AoIyaa__wrapper",
});
